import { render } from "./SocialLogin.vue?vue&type=template&id=1277d054&lang=pug"
import script from "./SocialLogin.vue?vue&type=script&lang=js"
export * from "./SocialLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__